// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AzureAksNodePoolTaintEffect = {
  NodePoolTaintEffectNoSchedule: 'NoSchedule',
} as const;
export type AzureAksNodePoolTaintEffect =
  (typeof AzureAksNodePoolTaintEffect)[keyof typeof AzureAksNodePoolTaintEffect];

export function instanceOfAzureAksNodePoolTaintEffect(value: any): boolean {
  for (const key in AzureAksNodePoolTaintEffect) {
    if (
      Object.prototype.hasOwnProperty.call(AzureAksNodePoolTaintEffect, key)
    ) {
      if (
        AzureAksNodePoolTaintEffect[
          key as keyof typeof AzureAksNodePoolTaintEffect
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AzureAksNodePoolTaintEffectFromJSON(
  json: any,
): AzureAksNodePoolTaintEffect {
  return AzureAksNodePoolTaintEffectFromJSONTyped(json, false);
}

export function AzureAksNodePoolTaintEffectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolTaintEffect {
  return json as AzureAksNodePoolTaintEffect;
}

export function AzureAksNodePoolTaintEffectToJSON(
  value?: AzureAksNodePoolTaintEffect | null,
): any {
  return value as any;
}

export function AzureAksNodePoolTaintEffectToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolTaintEffect {
  return value as AzureAksNodePoolTaintEffect;
}
